import { useTranslation } from "react-i18next";

export interface VendorPhone {
	contact?: {
		mobilePrefix?: string | null;
		mobile?: string | null;
		phonePrefix?: string | null;
		phone?: string | null;
	} | null;
}

const formatPhoneNumber = (
	number: string | null | undefined,
	prefix: string | null | undefined,
): string | null => {
	if (!number) return null;

	const formattedPrefix = prefix ? `+${prefix} ` : "";
	return `${formattedPrefix}${number}`;
};

export function getFormattedPhone({ contact }: VendorPhone) {
	const { t } = useTranslation("common");

	const mobileFormatted = formatPhoneNumber(
		contact?.mobile,
		contact?.mobilePrefix,
	);

	const phoneFormatted = formatPhoneNumber(
		contact?.phone,
		contact?.phonePrefix,
	);

	return { mobileFormatted, phoneFormatted };
}
